import React from 'react';
import { useI18n } from '../i18n/index.jsx';
import { isChunkLoadError, reloadOnceForNewBuild } from '../lazyWithReload.js';

// Last line of defence: any render error shows a message with a reload
// button instead of a blank page, and is logged to the console. A failed
// chunk import (old tab after a redeploy) reloads the page once first.
export default class ErrorBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[PME] Page error:', error, info?.componentStack);
    if (isChunkLoadError(error)) reloadOnceForNewBuild();
  }

  render() {
    return this.state.error ? <Fallback /> : this.props.children;
  }
}

function Fallback() {
  const { t } = useI18n();
  return (
    <div className="error-page" role="alert">
      <h1>{t('errorPage.title')}</h1>
      <p className="muted">{t('errorPage.text')}</p>
      <div className="hero-actions">
        <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>{t('errorPage.reload')}</button>
        <a className="btn btn-ghost" href="/">{t('errorPage.home')}</a>
      </div>
    </div>
  );
}
